import React, { useReducer } from 'react'
import ProductContext from './productContext'
import ProductReducer from './productReducer'
import { apiCall } from '../../common/apiCustom'
import { response } from '../common'

import {
    GET_ALL_PRODUCTS,
    GET_ALL_ACTIVE_AUCTIONS,
    GET_SINGLE_PROJECT,
    GET_ALL_BID_HISTORY,
    GET_ALL_TTWBID_HISTORY,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './productTypes'

const ProductState = (props) => {
    const initialState = {
        all_products: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_active_auctions: {
            activelots: [],
        },
        single_project: {
            record: {},
        },
        search_allbidhistory: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_allttwbidhistory: [],
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(ProductReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllProducts = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'listings', formData, '', 'product'),
            ])
            const from = 'Communicationtemplates'

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_PRODUCTS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
                dispatch({
                    type: GET_ALL_ACTIVE_AUCTIONS,
                    payload: res.data.data.responseData.activelots.length
                        ? res.data.data.responseData.activelots
                        : [],
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeProductStatus = async (formData) => {
        try {
            const from = 'productchange'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const projectAction = async (formData) => {
        try {
            const from = 'projectAction'
            const [res] = await Promise.all([
                apiCall('post', 'projectAction', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addItemToCart = async (formData) => {
        try {
            const from = 'addItemToCart'
            const [res] = await Promise.all([
                apiCall('post', 'addItemToCart', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const bulkProjectAction = async (formData) => {
        const from = 'bulkProjectAction'
        try {
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllBidHistory = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'bidhistory', formData, '', 'product'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_BID_HISTORY,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleProject = async (formData) => {
        try {
            const from = 'getSingleProject'
            const [res] = await Promise.all([
                apiCall('post', 'getSingleProject', formData, '', 'product'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_PROJECT,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllTtwBidHistory = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'ttwbidhistory', formData, '', 'product'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_TTWBID_HISTORY,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData.sorts,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            console.log('err', err)
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    const bidHistoryUpdate = async (formData) => {
        try {
            const from = 'bidHistoryUpdate'
            const [res] = await Promise.all([
                apiCall('post', 'ttwbidhistoryUpdate', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    return (
        <ProductContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                all_products: state.all_products,
                responseStatus: state.responseStatus,
                activelots: state.activelots,
                single_project: state.single_project,
                search_allbidhistory: state.search_allbidhistory,
                search_allttwbidhistory: state.search_allttwbidhistory,
                clearResponse,
                getAllProducts,
                changeProductStatus,
                projectAction,
                getSingleProject,
                bulkProjectAction,
                getAllBidHistory,
                getAllTtwBidHistory,
                bidHistoryUpdate,
                addItemToCart,
            }}
        >
            {props.children}
        </ProductContext.Provider>
    )
}

export default ProductState
